module.exports = __webpack_public_path__ + "img/logo.081352ce.png";